import React from 'react'
import { connect } from 'react-redux'
import OrderInformation from './OrderInformation'
import '@/assets/styles/components/order/order-journal-detail.scss';
import { dataType } from '@/constants/data-type';
import DataTable from '../DataTable/DataTable';
import { PARAMS } from '@/constants/params';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { ORDER_MODE } from '@/constants/app';
import classnames from 'classnames';
import { formatFunctions } from '../../helpers/functions';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import OrderAudit from './OrderAudit';
import { ORDER_FILTER_STATUS } from '@/constants/filter-type'
import { COMPANY_SUPPORTS } from '@/constants/companys';

class OrderJournalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: props.language.order_execution_date_time,
          colId: 'order_execution_date_time',
          field: 'tradeTime',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          sortable: false
        },
        {
          headerName: props.language.order_execution_quantity,
          colId: 'order_execution_quantity',
          field: 'qty',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          sortable: false
        },
        {
          headerName: props.language.order_execution_price,
          colId: 'order_execution_price',
          field: 'price',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          sortable: false
        }
      ],
      orderData: props.order,
      executionData: [],
      auditList: [],
      isLoading: true
    }
  }
  render() {
    const { language, isMobile, enabledFetchAudit, enabledFetchExecute } = this.props;
    const { columnDefs, executionData, auditList, orderData, isLoading } = this.state;
    return (
      <div className={classnames("order-detail-container", isMobile && "order-detail-mobile-container")}>
        {!isLoading && <React.Fragment>
          <section>
            <header className="order-status">{language.order_latest_status}: {appEnvironment.company === COMPANY_SUPPORTS.SCB ? language[`order_status_query_${orderData.status.toLowerCase()}`]  :
              language[`order_status_${orderData.status.toLowerCase()}`]}</header>
            <OrderInformation order={orderData} mode={isMobile ? ORDER_MODE.CANCEL : ORDER_MODE.DETAIL} />
          </section>
          <section>
            {enabledFetchAudit && auditList.length > 0 ? <OrderAudit auditList={auditList} /> :
              <div style={{ textAlign: 'center' }}>{language.common_no_data}</div>}
            {enabledFetchExecute && <React.Fragment>
              <header>{language.order_audit}</header>
              {executionData.length > 0
                ? <React.Fragment>
                  {isMobile
                    ? <div className="execution-list">
                      <header>
                        <span>{language.common_date_time}</span>
                        <span>{language.common_quantity}</span>
                        <span>{language.common_price}</span>
                      </header>
                      {executionData.map(item =>
                        <div className="execution-item" key={item.orderID + item.tradeTime}>
                          <span>{formatFunctions.dataFormat(item.tradeTime, dataType.LONG_DATE)}</span>
                          <span>{formatFunctions.dataFormat(item.qty, dataType.NUMBER)}</span>
                          <span>{formatFunctions.dataFormat(item.price, dataType.CURRENCY)}</span>
                        </div>
                      )}
                    </div>
                    : <div className="execution-table" style={{ height: (executionData.length + 1) * 30 + 3 }}>
                      <DataTable columnDefs={columnDefs} data={executionData} showPagination={false} />
                    </div>
                  }
                </React.Fragment>
                : <div style={{ textAlign: 'center' }}>{language.common_no_data}</div>
              }</React.Fragment>}
            {/* <div className="outstanding-qty">
              <span>{language.common_outstanding_quantity}</span>
              <span>{formatFunctions.dataFormat(orderData.osqty, dataType.NUMBER)}</span>
            </div> */}
          </section>
          <section>
            <header>{language.common_note}:</header>
            <div className='note-content'>
              <ol>
                <li>{language.order_note_line_1}</li>
                <li>{language.order_note_line_2}</li>
              </ol>
            </div>
          </section>
        </React.Fragment>}
      </div>
    )
  }

  getStatusLabel = (status) => {
    let key = ''
    for (let i = 0; i < ORDER_FILTER_STATUS.length; i++) {
      if (ORDER_FILTER_STATUS[i].value.includes(status)) {
        key = ORDER_FILTER_STATUS[i].label
      }
    }
    return key
  }

  getData() {
    const {
      currentTradingAccount,
      language,
      order,
      forceDate,
      dateFilter,
      enabledFetchAudit,
      enabledFetchExecute
    } = this.props
    if (currentTradingAccount.clientID) {
      
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.GET_AUDIT_DETAIL]: enabledFetchAudit ? 'Y' : 'N',
        [PARAMS.GET_EXECUTE_DETAIL]: enabledFetchExecute ? 'Y' : 'N'
      }
      if (forceDate) {
        params[PARAMS.START_DATE] = dateFilter[PARAMS.START_DATE],
          params[PARAMS.END_DATE] = dateFilter[PARAMS.END_DATE]
      }

      this.props.getOrderDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : order;
            let auditListRaw = [];
            if (res.result.auditList.length > 0) {
              auditListRaw = res.result.auditList.map(v => {
                return {
                  ...v,
                  // status: v.statusDesc,
                  stockCode: orderData.instrumentID,
                  marketID: orderData.marketID,
                  bs: orderData.bs
                }
              })
            }
            this.setState({
              executionData: res.result.executedList,
              orderData: orderData,
              auditList: auditListRaw
            });
          }
        }
        this.setState({ isLoading: false })
      })
    }
  }

  componentDidMount() {
    this.getData();
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c))
  })
)(OrderJournalDetail)
